import React, { useState } from 'react';
import EmbedCode from 'app/scripts/components/common/embed-code';
import SelectInput from 'utils/components/select-input';
import { copyToClipboard } from 'app/scripts/services/copy-to-clipboard';

interface Props {
  eventCode: string;
}

enum ImplementationMethod {
  OneProduct = '0',
  MoreThanOneProduct = '1'
}

const IMPLEMENTATION_METHODS: { value: ImplementationMethod; text: string }[] = [
  {
    value: ImplementationMethod.OneProduct,
    text: 'This is the only OpenWeb product used on the page'
  },
  {
    value: ImplementationMethod.MoreThanOneProduct,
    text: `There are other OpenWeb products used on the page`
  }
];

const LiveEventEmbedCode: React.FC<Props> = ({ eventCode = '' }) => {
  const [method, setMethod] = useState<ImplementationMethod>(ImplementationMethod.OneProduct);

  const copyEventCodeToClipboard = () => {
    copyToClipboard(eventCode);
  };

  return (
    <div className={'live-blog-embed-code'}>
      <SelectInput
        title={<h6 className={'live-blog-embed-code-title'}>Embed code</h6>}
        description={<p>Select the relevant code to embed in the event page.</p>}
        onChange={option => setMethod(option.value)}
        options={IMPLEMENTATION_METHODS}
        value={IMPLEMENTATION_METHODS[Number(method)]}
      />
      {method === ImplementationMethod.OneProduct && (
        <EmbedCode type="live-event-1" eventCode={eventCode} />
      )}
      {method === ImplementationMethod.MoreThanOneProduct && (
        <EmbedCode type="live-event-2" eventCode={eventCode} />
      )}
      <div className={'implementation-details'}>
        Copy this code and embed it where you want the event updates to appear.
        <br />* For internal use only:{' '}
        <span className={'copy-event-text'} onClick={copyEventCodeToClipboard}>
          copy event ID
        </span>
        .
      </div>
    </div>
  );
};

export default LiveEventEmbedCode;
